import { lazy, Suspense, useState } from 'react';
const SupervisorRuns = lazy(() => import('./SupervisorRuns.jsx'));
export default function SessionRunRecovery({sessionId}) {
  const [open,setOpen]=useState(false);
  if (!window.apolo?.agentSupervisor || localStorage.getItem('apolo:runtime:v2') !== '1') return null;
  return <details className="max-h-80 overflow-auto border-b border-apolo-borderSubtle px-4" onToggle={(event)=>setOpen(event.currentTarget.open)}>
    <summary className="flex min-h-11 cursor-pointer items-center text-sm">Execuções salvas deste chat</summary>
    {open && <Suspense fallback={<p>Recuperando execução…</p>}><SupervisorRuns key={sessionId} sessionId={sessionId} /></Suspense>}
  </details>;
}
